import { problems } from "@/mocks/problems";

const accentMap = [
  { dot: "bg-primary-500", num: "bg-primary-100 text-primary-700", head: "text-primary-700", ring: "ring-primary-100" },
  { dot: "bg-secondary-500", num: "bg-secondary-100 text-secondary-700", head: "text-secondary-700", ring: "ring-secondary-100" },
  { dot: "bg-accent-500", num: "bg-accent-100 text-accent-700", head: "text-accent-700", ring: "ring-accent-100" },
];

export default function Solutions() {
  return (
    <section id="solutions" className="scroll-mt-20 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="mx-auto max-w-2xl text-center">
          <span className="inline-block rounded-full bg-accent-100 px-4 py-1 text-sm font-medium text-accent-900">
            详细解决方案
          </span>
          <h2 className="mt-4 text-2xl font-black text-foreground-950 md:text-4xl">
            按步骤排查，问题迎刃而解
          </h2>
          <p className="mt-3 text-sm leading-7 text-foreground-600 md:text-base">
            每个问题都整理成由易到难的排查步骤，从第一步开始，多数问题在第 1–2 步就能解决。
          </p>
        </div>

        <div className="mt-12 space-y-8">
          {problems.map((p, i) => {
            const c = accentMap[i % accentMap.length];
            return (
              <article
                key={p.id}
                id={p.id}
                className="grid scroll-mt-24 grid-cols-1 gap-6 rounded-2xl border border-background-200 bg-background-50 p-6 md:grid-cols-[300px_1fr] md:p-8"
              >
                <div className="flex items-start gap-4 md:flex-col md:items-start md:gap-0">
                  <span
                    className={`flex h-14 w-14 items-center justify-center rounded-2xl text-2xl ${c.dot} text-background-50`}
                  >
                    <i className={p.icon} />
                  </span>
                  <div className="md:mt-5">
                    <span className={`text-sm font-medium ${c.head}`}>{p.keyword} · 排查方案</span>
                    <h3 className="mt-1 text-xl font-bold text-foreground-950">{p.title}</h3>
                    <p className="mt-2 text-sm leading-6 text-foreground-600">{p.brief}</p>
                  </div>
                </div>

                <ol className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                  {p.steps.map((s, si) => (
                    <li
                      key={s.title}
                      className="flex gap-3 rounded-xl border border-background-200 bg-background-50 p-4"
                    >
                      <span
                        className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full text-sm font-bold ${c.num}`}
                      >
                        {si + 1}
                      </span>
                      <div>
                        <h4 className="text-sm font-bold text-foreground-900">{s.title}</h4>
                        <p className="mt-1.5 text-sm leading-6 text-foreground-600">{s.desc}</p>
                      </div>
                    </li>
                  ))}
                </ol>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}